import React, { useEffect, useState } from 'react';
import { Form, Button, Container, Row, Col, Card } from 'react-bootstrap';
import { FaUpload } from 'react-icons/fa';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSpinner } from '../../../Utilities/SpinnerContext';
import './CreateShelf.css';  // Optional custom CSS file for styling
import ToastrNotifi from '../../../Utilities/ToastrNotifi';
import { useUpdateShelve } from '../../../hooks/useShelveData';

const EditShelve = () => {
    const [shelfName, setShelfName] = useState('');
    const [shelfImage, setShelfImage] = useState(null);  // Image file for submission
    const [imagePreview, setImagePreview] = useState('');  // Image URL for preview
    const [shelfDescription, setShelfDescription] = useState('');
    const [previousImgRow, setPreviousImgRow] = useState(''); // Store path for backend

    const beURL = localStorage.getItem('BeURL');
    const location = useLocation();
    const { shelve_ID } = location.state || {};
    const { showSpinner, hideSpinner } = useSpinner();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});


    const { mutate: updateShelve } = useUpdateShelve();

    useEffect(() => {
        if (shelve_ID) {
            showSpinner();
            axios.get(`${beURL}shelve/${shelve_ID}`)
                .then(response => {
                    const shelfData = response.data.shelve;
                    setShelfName(shelfData?.name);
                    setShelfDescription(shelfData?.description);
                    const img_path = beURL + shelfData?.image_path;
                    setImagePreview(img_path); // Current image preview
                    setPreviousImgRow(shelfData?.image_path); // Save original image path for backend
                    hideSpinner();
                })
                .catch(error => {
                    console.error('Error fetching shelf data:', error);
                    hideSpinner();
                });
        }
    }, [shelve_ID, beURL]);

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setShelfImage(file);  // Store the file for form submission
            setImagePreview(URL.createObjectURL(file));  // Generate preview URL
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('shelfName', shelfName);
        formData.append('shelfDescription', shelfDescription);
        if (shelfImage) formData.append('shelfImage', shelfImage);  // Only append if new image
        formData.append('shelfId', shelve_ID);
        formData.append('shelve_preImage', previousImgRow);

        updateShelve(formData, {
            onSuccess: () => {
                ToastrNotifi.successToast("Shelf updated successfully");
                navigate(-1);
            },
            onError: (error) => {
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrors(error.response.data.errors);
                    const errorMessages = Object.values(error.response.data.errors).flat();
                    errorMessages.forEach(message => ToastrNotifi.warningToast(message));
                } else {
                    console.error('An unexpected error occurred:', error);
                    ToastrNotifi.errorToast("An unexpected error occurred. Please try again.");
                }
            },
        });
    };

    return (
        <Container className="mt-4">
            <Row className="justify-content-center">
                <Col md={8}>
                    <Card className="p-4 shadow-sm">
                        <h3 className="text-center mb-4">Edit Shelf</h3>
                        <Form onSubmit={handleSubmit}>
                            {/* Shelf Name */}
                            <Form.Group controlId="shelfName" className="mb-3">
                                <Form.Label>Shelf Name
                                    {errors.shelfName ? (
                                        <div className="text-danger error-text">**{errors.shelfName}</div>
                                    ) : (null)}
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter shelf name"
                                    value={shelfName}
                                    onChange={(e) => setShelfName(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            {/* Shelf Image */}
                            <Form.Group controlId="shelfImage" className="mb-3">
                                <Form.Label>Shelf Image
                                {errors.shelfImage ? (
                                                <div className="text-danger error-text">**{errors.shelfImage}</div>
                                            ) : (null)}
                                </Form.Label>
                                <div className="custom-file-upload">
                                    <Form.Control
                                        type="file"
                                        accept="image/*"
                                        onChange={handleImageUpload}
                                    />
                                    <FaUpload className="upload-icon" />
                                </div>
                                {/* Image Preview */}
                                {imagePreview && (
                                    <div className="mt-3">
                                        <img
                                            width={225}
                                            src={imagePreview}
                                            alt="Shelf Preview"
                                            className="shelf-image-preview"
                                        />
                                    </div>
                                )}
                            </Form.Group>

                            {/* Shelf Description */}
                            <Form.Group controlId="shelfDescription" className="mb-3">
                                <Form.Label>Shelf Description
                                {errors.shelfDescription ? (
                                                <div className="text-danger error-text">**{errors.shelfDescription}</div>
                                            ) : (null)}
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder="Enter shelf description"
                                    value={shelfDescription}
                                    onChange={(e) => setShelfDescription(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            {/* Submit Button */}
                            <div className="text-center">
                                <Button variant="primary" type="submit" className="px-4">
                                    Update Shelf
                                </Button>
                            </div>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default EditShelve;
